import { useEffect, useState, useCallback, useRef } from "react";
import axiosInstance from "services/AxiosInstance";

const API_URL = "/api/v3/zonas-sociales/activos/programaciones/";

export const useProgramacionesMantenimiento = (filters = {}) => {
  const [programaciones, setProgramaciones] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
  });

  // Use ref to avoid re-renders when filters object reference changes
  const filtersRef = useRef(filters);
  filtersRef.current = filters;

  const fetchProgramaciones = useCallback(async (page = 1) => {
    try {
      setIsLoading(true);
      const params = new URLSearchParams({ page, ...filtersRef.current });
      const response = await axiosInstance.get(`${API_URL}?${params.toString()}`);
      setProgramaciones(response.data.results || response.data);
      setPagination({
        count: response.data.count || 0,
        next: response.data.next || null,
        previous: response.data.previous || null,
      });
      setError(null);
    } catch (err) {
      setError(err);
      console.error("Error fetching programaciones:", err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProgramaciones();
  }, []);

  const createProgramacion = async (data) => {
    const response = await axiosInstance.post(API_URL, data);
    await fetchProgramaciones();
    return response.data;
  };

  const updateProgramacion = async (uuid, data) => {
    const response = await axiosInstance.patch(`${API_URL}${uuid}/`, data);
    await fetchProgramaciones();
    return response.data;
  };

  const deleteProgramacion = async (uuid) => {
    await axiosInstance.delete(`${API_URL}${uuid}/`);
    await fetchProgramaciones();
  };

  return {
    programaciones,
    isLoading,
    error,
    pagination,
    fetchProgramaciones,
    createProgramacion,
    updateProgramacion,
    deleteProgramacion,
  };
};
